import React from "react";
import MyGoal1 from "../../../../assets/img/icon1.png";
import MyGoal2 from "../../../../assets/img/icon2.png";
import MyGoal3 from "../../../../assets/img/icon3.png";
import MyGoal4 from "../../../../assets/img/icon4.png";
import MyGoal5 from "../../../../assets/img/icon5.png";
import MyGoal6 from "../../../../assets/img/icon6.png";
import ApiEncryptDecrypt from "../../../../Utils/Encryption";
import { toast } from "react-toastify";
const AssociateReferalTeam = () => {
  return (
    <div className="col-12 col-xl-6 ">
      <div className="card border h-100 w-100 overflow-hidden">
        <div className="card-body p-4">
          <ul class="goal-icon">
            <li>
              <a href="javascript:void(0)">
                <img class="card-img-top" src={MyGoal1} alt="" />
                <strong>Goal</strong>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <img class="card-img-top" src={MyGoal2} alt="" />
                <strong>Business Card</strong>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <img class="card-img-top" src={MyGoal3} alt="" />
                <strong>My Brochure</strong>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <img class="card-img-top" src={MyGoal4} alt="" />
                <strong>E-book</strong>
                <p>coming soon</p>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <img class="card-img-top" src={MyGoal5} alt="" />
                <strong>Audiobook</strong>
                <p>coming soon</p>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <img class="card-img-top" src={MyGoal6} alt="" />
                <strong>Video Conference</strong>
                <p>coming soon</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AssociateReferalTeam;
